import React, { useState } from 'react'
import { findFilter, setOrDropFilter } from 'components/Shared/Table/TableFiltersRow/utils'
import { useTranslation } from 'react-i18next'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'

const CHECKED = true
const UNCHECKED = false
const INDETERMINATE = null

function BooleanFilter ({ column, filters, onFiltersChanged }) {
  const filterName = column.filterName || column.id
  const filter = findFilter(filters, filterName)
  const [value, setValue] = useState(filter ? filter.value === 'true' : INDETERMINATE)

  const { t } = useTranslation()

  const getNewValue = (previousValue) => {
    switch (previousValue) {
      case INDETERMINATE:
        return CHECKED
      case CHECKED:
        return UNCHECKED
      case UNCHECKED:
      default:
        return INDETERMINATE
    }
  }

  const handleChange = () => {
    const newValue = getNewValue(value)
    setValue(newValue)

    const newFilters = setOrDropFilter(filters, filterName, newValue?.toString())
    onFiltersChanged(newFilters)
  }

  return (<>
      {t('form.select.title') + ':'}
      <PrimaryCheckbox
        id={column.id}
        onChange={handleChange}
        checked={value === CHECKED}
        indeterminate={value === INDETERMINATE}
      />
    </>
  )
}

export default BooleanFilter